<script>
    import Layout from "../../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Forms from "../../../../mixins/Forms";
    import {Editor, EditorContent, EditorMenuBar} from 'tiptap';
    import {
        Blockquote,
        CodeBlock,
        HardBreak,
        Heading,
        OrderedList,
        BulletList,
        ListItem,
        TodoItem,
        TodoList,
        Bold,
        Code,
        Italic,
        Link,
        Strike,
        Underline,
        History,
    } from 'tiptap-extensions';


    import axios from 'axios';

    /**
     * Ticket email template edit component
     */
    export default {
        page: {
            title: "Edit Ticket Email Template",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {Layout, PageHeader, EditorMenuBar, EditorContent},
        mixins: [Forms],
        mounted() {
            this.setupEditor();
        },
        created() {
            this.loadTicketEmailTemplate(this.$route.params.id);
        },
        data() {
            return {
                title: "Edit Ticket Email Template",
                items: [
                    {
                        text: "Settings",
                        href: "#"
                    },
                    {
                        text: "Edit Ticket Email Template",
                        active: true
                    }
                ],
                ticketEmailTemplate: null,
                serverErrors: [],
                isLoading: false,
                isSaving: false,
                editor: null
            };
        },
        methods: {
           loadTicketEmailTemplate(id) {
               let vm = this;
               vm.ticketEmailTemplate = null;
               vm.isLoading = true;
               axios.get(API_BASE + '/ticket-email-templates/' + id).then(r => {
                   vm.isLoading = false;
                   vm.ticketEmailTemplate = r.data;
                   vm.editor.setContent(vm.ticketEmailTemplate.body);
               }).catch(e => {
                   console.log(e);
                   vm.isLoading = false;
                   vm.setErrors(e);
               });
           },

            attemptSave() {
                this.save();
            },

            save() {
                let vm = this;
                vm.isSaving = true;
                axios.put(API_BASE + '/ticket-email-templates/' + this.ticketEmailTemplate.id, {
                    name: vm.ticketEmailTemplate.name,
                    body: vm.editor.getHTML()
                }).then(r => {
                    vm.isSaving = false;
                    vm.$router.push('/settings/ticket-email-templates/');
                    this.$notify.success({
                        title: 'Success!',
                        message: 'Template updated successfully'
                    });
                }).catch(e => {
                    console.log(e);
                    vm.isSaving = false;
                    vm.setErrors(e);
                });
            },

            setupEditor() {
                let vm = this;
                this.editor = new Editor({
                    extensions: [
                        new Blockquote(),
                        new CodeBlock(),
                        new HardBreak(),
                        new Heading({levels: [1, 2, 3]}),
                        new BulletList(),
                        new OrderedList(),
                        new ListItem(),
                        new TodoItem(),
                        new TodoList(),
                        new Bold(),
                        new Code(),
                        new Italic(),
                        new Link(),
                        new Strike(),
                        new Underline(),
                        new History(),
                    ]
                })
            }
        }
    };
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items"/>
        <errors :error-list="serverErrors"></errors>
        <loading-screen :is-loading="isLoading||isSaving"></loading-screen>
        <div class="row" v-if="ticketEmailTemplate">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <!--            <h4 class="card-title mb-4">Ticket Details</h4>-->
                        <form @submit.prevent="attemptSave">
                            <div class="form-group row mb-4">
                                <label for="subject" class="col-form-label col-lg-2">Name</label>
                                <div class="col-lg-10">
                                    <input
                                            id="name"
                                            name="name"
                                            type="text"
                                            class="form-control"
                                            v-model="ticketEmailTemplate.name"
                                            autofocus
                                    />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="template" class="col-form-label col-lg-2">Template</label>
                                <div class="col-lg-10">
                                    <div class="card shadow-none card-action">
                                        <div class="card-body pb-0">
                                            <editor-content :editor="editor"/>
                                        </div>
                                        <div class="card-menubar">
                                            <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
                                                <div class="menubar">

                                                    <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                                                       :class="{ 'is-active': isActive.bold() }"
                                                       @click="commands.bold"
                                                    >
                                                        <i class="fas fa-bold"></i>
                                                    </a>

                                                    <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                                                       :class="{ 'is-active': isActive.italic() }"
                                                       @click="commands.italic"
                                                    >
                                                        <i class="fas fa-italic"></i>
                                                    </a>

                                                    <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                                                       :class="{ 'is-active': isActive.strike() }"
                                                       @click="commands.strike"
                                                    >
                                                        <i class="fas fa-strikethrough"></i>
                                                    </a>

                                                    <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                                                       :class="{ 'is-active': isActive.underline() }"
                                                       @click="commands.underline"
                                                    >
                                                        <i class="fas fa-underline"></i>
                                                    </a>

                                                    <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                                                       :class="{ 'is-active': isActive.bullet_list() }"
                                                       @click="commands.bullet_list"
                                                    >
                                                        <i class="fas fa-list-ul"></i>
                                                    </a>

                                                    <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                                                       :class="{ 'is-active': isActive.ordered_list() }"
                                                       @click="commands.ordered_list"
                                                    >
                                                        <i class="fas fa-list-ol"></i>
                                                    </a>

                                                    <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                                                       @click="commands.undo"
                                                    >
                                                        <i class="fas fa-undo"></i>
                                                    </a>

                                                    <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                                                       @click="commands.redo"
                                                    >
                                                        <i class="fas fa-redo"></i>
                                                    </a>
                                                </div>
                                            </editor-menu-bar>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </form>
                        <div class="row justify-content-end">
                            <div class="col-lg-10">
                                <button type="submit" class="btn btn-itg-dark" @click.prevent="attemptSave">Update</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- end row -->
    </Layout>
</template>

<style scoped>
</style>
